import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import Campaigns from './Campaigns';
import Influencers from './Influencers/Influencers'
import ProjectManagerCampaign from "./Campaign/ProjectManagerCampaign";
import ProjectManagers from './ProjectManager/ProjectManagers';
import Header from './Dashboard/Header';
import Brands from './Brands/Brands';
import BrandOverview from './Brands/BrandOverview';
import CurrentProjectManagerProvider from '../../contexts/CurrentProjectManagerContext'
import { SidebarCollapseProvider } from '../../contexts/SidebarCollapseContext'
import NewProjectManager from './ProjectManager/NewProjectManager';
import EditProjectManager from './ProjectManager/EditProjectManager';
import EditProjectManagerProfile from "./ProjectManager/EditProjectManagerProfile";
import NewCampaign from './Campaigns/NewCampaign';
import EditCampaign from './Campaigns/EditCampaign';
import InfluencerPage from './Influencer/InfluencerPage';
import PotentialInfluencersTable from './PotentialInfluencer/PotentialInfluencersTable';
import PotentialInfluencerPage from './PotentialInfluencer/PotentialInfluencerPage';
import AuditLog from './AuditLog/AuditLog';

export default function ProjectManagerDashboardRoutes() {

  return (
    <div>
      <CurrentProjectManagerProvider>
        <SidebarCollapseProvider>
          <Header />
          <div>
            <Routes>
            <Route path="campaigns/new" element={<NewCampaign />} />
            <Route path="campaigns/archived" element={<Campaigns archived />} />
            <Route path="campaigns/:id/edit" element={<EditCampaign />} />
            <Route path="campaigns/:id/*" element={<ProjectManagerCampaign />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="campaigns/clients/:client_id" element={<Campaigns />} />
            <Route path="campaigns/clients/:client_id/folders/:folder_id" element={<Campaigns />} />
            <Route path="brands" element={<Brands />} />
            <Route path="brands/:id" element={<BrandOverview />} />
            <Route path="potential_influencers" element={<PotentialInfluencersTable />} />
            <Route path="potential_influencers/:id" element={<PotentialInfluencerPage />} />
            <Route path="influencers" element={<Influencers />} />
            <Route path="influencers/campaign/:campaign_id/status/:campaign_status_id" element={<Influencers />} />
            <Route path="authentications/:id/influencer" element={<Navigate to="overview" replace />} />
            <Route path="authentications/:id/influencer/*" element={<InfluencerPage />} />
            <Route path="project-managers" element={<ProjectManagers />} />
            <Route path="project-managers/new" element={<NewProjectManager />} />
            <Route path="project-managers/:id" element={<EditProjectManager />} />
            <Route path="edit_profile" element={<EditProjectManagerProfile />} />
            <Route path="audit-log" element={<AuditLog />} />
            </Routes>
          </div>
        </SidebarCollapseProvider>
      </CurrentProjectManagerProvider>
    </div>
  )
}
